<template>
  <Layout>
    <div class="container" v-if="event">
      <div class="schedule-top">
        <div class="title">Schedule For {{ event.conference_name }}</div>
        <div class="actions">
          <RouterLink
            style="text-decoration: none"
            :to="{
              name: 'school-edit-events'
            }"
            data-cy="goto-event-edit-btn"
          >
            <div class="action">
              <v-icon class="icon">mdi-calendar-edit</v-icon>
              <span class="text">Edit</span>
            </div>
          </RouterLink>
          <RouterLink
            style="text-decoration: none"
            :to="{
              name: 'school-reports'
            }"
            data-cy="goto-reports"
          >
            <div class="action">
              <v-icon class="icon">mdi-chart-box</v-icon>
              <span class="text">Reports</span>
            </div>
          </RouterLink>
        </div>
      </div>

      <div class="schedule-body">
        <schedule-body :event-id="eventId"></schedule-body>
      </div>
    </div>
    <div v-if="!event && confStore.loading" style="width: 100%; margin-top: 200px">
      <LoadingState text="Loading Schedule..."></LoadingState>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import Layout from "./Layout.vue";
import { useConferenceStore } from "@/stores/teacher/conference";
import { cloneDeep } from "lodash";
import LoadingState from "@/components/loadingState.vue";
import ScheduleBody from "@/components/school/schedule/ScheduleBody.vue";
import { sort } from "@/utils/sort";

const props = defineProps<{
  eventId: string;
  account?: string;
}>();

const confStore = useConferenceStore();

const event = computed(() => confStore.selected!);

const setEvent = async () => {
  await confStore.loadingPromise;
  const event = confStore.conferences.find((c) => c.conference_id === +props.eventId);
  if (event) {
    confStore.selected = cloneDeep(event);
    confStore.selected.conference_days = sort(confStore.selected.conference_days, (i) => i.start);
  }
};
setEvent();
watch([() => props.eventId, () => confStore.conferences], setEvent);
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.schedule-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  .title {
    font-size: 1.25rem;
    color: gray;
    font-weight: 600;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    //   width: 100%;
    gap: 20px;
    flex-grow: 1;
    .action {
      color: $primary;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 5px;
      border-radius: 4px;

      &:active {
        outline: 2px solid $primary-75;
      }
      gap: 5px;
      .icon {
        font-size: 1.5rem;
        font-weight: 600;
        flex-grow: 1;
      }
      .text {
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }
}
</style>
